import styled from "styled-components";
import Icon from "components/atomics/Icon";

export const Settings = styled(Icon)`
  padding-left: ${({ theme }) => theme.spacing(8)};
  cursor: pointer;
`;
